// src/services/profileBannerApi.js

import api from '../api';

const getCatalogue = async () => {
  const response = await api.get('/profile-banners');
  return response.data;
};

const getMyBanners = async () => {
  const response = await api.get('/profile-banners/mine');
  return response.data;
};

const startTrial = async (bannerId) => {
  if (!bannerId) {
    throw new Error('Banner ID is required to start a trial.');
  }

  const response = await api.post(
    `/profile-banners/${bannerId}/start-trial`
  );

  return response.data;
};

const purchaseBanner = async (bannerId) => {
  if (!bannerId) {
    throw new Error('Banner ID is required to purchase a banner.');
  }

  const response = await api.post(
    `/profile-banners/${bannerId}/purchase`
  );

  return response.data;
};

const equipBanner = async (bannerId) => {
  if (!bannerId) {
    throw new Error('Banner ID is required to equip a banner.');
  }

  const response = await api.post(
    `/profile-banners/${bannerId}/equip`
  );

  return response.data;
};

const unequipBanner = async () => {
  const response = await api.post('/profile-banners/unequip');
  return response.data;
};

const profileBannerApi = {
  getCatalogue,
  getMyBanners,
  startTrial,
  purchaseBanner,
  equipBanner,
  unequipBanner,
};

export {
  getCatalogue,
  getMyBanners,
  startTrial,
  purchaseBanner,
  equipBanner,
  unequipBanner,
};

export default profileBannerApi;
